import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";

export const Footer = () => {
  const useStyles = makeStyles(() => ({
    footer: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      boxShadow: "0 0 3px 0 rgba(225, 225, 225, 0.5)",
      backgroundColor: "#FFFFFF",
      padding: "12.4px 29px 10px 29.7px",
    },
    text: {
      fontSize: 10,
      color: "#a6a6a6",
    },
    logoFooterWrapper: {
      display: "flex",
      alignItems: "center",
    },
    logoFooter: {
      maxWidth: 90,
      marginLeft: 30,
    },
  }));
  const classes = useStyles();
  return (
    <Box>
      <div className={classes.footer}>
        <span>
          <Typography className={classes.text}>
            © {new Date().getFullYear()}
          </Typography>
        </span>
        <span className={classes.logoFooterWrapper}>
          <Typography className={classes.text}>powered by</Typography>
          <img
            className={classes.logoFooter}
            src="/logo-mentoro.webp"
            alt="mentoro"
          />
        </span>
      </div>
    </Box>
  );
};
